import axios from 'axios';
import { getApiBaseUrl } from './apiConfig';
import { getStorageValues } from '../shared/CommonFunctions';

const FALLBACK_MODULE = 'Client Company Type';

export const logAuditEvent = async (moduleName, action, details = '') => {
  try {
    const userId = getStorageValues('userId');
    if (!userId) {
      return;
    }

    await axios.post(getApiBaseUrl() + '/logAuditEvent', {
      UserId: userId,
      ModuleName: moduleName || FALLBACK_MODULE,
      Action: action,
      Details: details
    });
  } catch (error) {
    console.error('Failed to log audit event', error);
  }
};
